// src/config/constants.js
export const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1';

// ================================
// CONSTANTES FINANCIÈRES
// ================================

// Types de paiement - sync avec backend
export const PAYMENT_TYPES = {
  RENTAL: 'rental',
  DEPOSIT: 'deposit',
  PENALTY: 'penalty',
  COMMISSION: 'commission',
  TAX: 'tax',
  REFUND: 'refund',
  DAMAGE_COMPENSATION: 'damage_compensation',
  DEPOSIT_REFUND: 'deposit_refund',
  RENTAL_REFUND: 'rental_refund',
  COMMISSION_REFUND: 'commission_refund'
};

// Labels des types de paiement pour l'affichage
export const PAYMENT_TYPE_LABELS = {
  [PAYMENT_TYPES.RENTAL]: 'Location',
  [PAYMENT_TYPES.DEPOSIT]: 'Caution',
  [PAYMENT_TYPES.PENALTY]: 'Pénalité',
  [PAYMENT_TYPES.COMMISSION]: 'Commission',
  [PAYMENT_TYPES.TAX]: 'Taxe',
  [PAYMENT_TYPES.REFUND]: 'Remboursement',
  [PAYMENT_TYPES.DAMAGE_COMPENSATION]: 'Dédommagement',
  [PAYMENT_TYPES.DEPOSIT_REFUND]: 'Remboursement caution',
  [PAYMENT_TYPES.RENTAL_REFUND]: 'Remboursement location',
  [PAYMENT_TYPES.COMMISSION_REFUND]: 'Remboursement commission'
};

// Statuts des paiements - sync avec backend
export const PAYMENT_STATUSES = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  PARTIALLY_REFUNDED: 'partially_refunded'
};

// Labels des statuts de paiement
export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUSES.PENDING]: 'En attente',
  [PAYMENT_STATUSES.COMPLETED]: 'Complété',
  [PAYMENT_STATUSES.FAILED]: 'Échec',
  [PAYMENT_STATUSES.CANCELLED]: 'Annulé',
  [PAYMENT_STATUSES.REFUNDED]: 'Remboursé',
  [PAYMENT_STATUSES.PARTIALLY_REFUNDED]: 'Partiellement remboursé'
};

// Couleurs des statuts de paiement
export const PAYMENT_STATUS_COLORS = {
  [PAYMENT_STATUSES.PENDING]: 'warning',
  [PAYMENT_STATUSES.COMPLETED]: 'success',
  [PAYMENT_STATUSES.FAILED]: 'error',
  [PAYMENT_STATUSES.CANCELLED]: 'default',
  [PAYMENT_STATUSES.REFUNDED]: 'info',
  [PAYMENT_STATUSES.PARTIALLY_REFUNDED]: 'secondary'
};

// Statuts des dépôts - sync avec backend
export const DEPOSIT_STATUSES = {
  HELD: 'held',
  PAID: 'paid',
  REFUNDED: 'refunded',
  PENDING: 'pending',
  WITHHELD: 'withheld'
};

// Labels des statuts de dépôt
export const DEPOSIT_STATUS_LABELS = {
  [DEPOSIT_STATUSES.HELD]: 'Retenu',
  [DEPOSIT_STATUSES.PAID]: 'Payé',
  [DEPOSIT_STATUSES.REFUNDED]: 'Remboursé',
  [DEPOSIT_STATUSES.PENDING]: 'En attente',
  [DEPOSIT_STATUSES.WITHHELD]: 'Retenu (dommages)'
};

// Couleurs des statuts de dépôt
export const DEPOSIT_STATUS_COLORS = {
  [DEPOSIT_STATUSES.HELD]: 'warning',
  [DEPOSIT_STATUSES.PAID]: 'success',
  [DEPOSIT_STATUSES.REFUNDED]: 'info',
  [DEPOSIT_STATUSES.PENDING]: 'default',
  [DEPOSIT_STATUSES.WITHHELD]: 'error'
};

// Statuts des payouts owner - sync avec backend
export const PAYOUT_STATUSES = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
};

// Labels des statuts de payout
export const PAYOUT_STATUS_LABELS = {
  [PAYOUT_STATUSES.PENDING]: 'En attente',
  [PAYOUT_STATUSES.PROCESSING]: 'En traitement',
  [PAYOUT_STATUSES.COMPLETED]: 'Complété',
  [PAYOUT_STATUSES.FAILED]: 'Échec',
  [PAYOUT_STATUSES.CANCELLED]: 'Annulé'
};

// Couleurs des statuts de payout
export const PAYOUT_STATUS_COLORS = {
  [PAYOUT_STATUSES.PENDING]: 'warning',
  [PAYOUT_STATUSES.PROCESSING]: 'info',
  [PAYOUT_STATUSES.COMPLETED]: 'success',
  [PAYOUT_STATUSES.FAILED]: 'error',
  [PAYOUT_STATUSES.CANCELLED]: 'default'
};

// ================================
// CONFIGURATION FINANCIÈRE
// ================================

// Commission par défaut de la plateforme
export const PLATFORM_COMMISSION_RATE = 0.08; // 8%

// Montants minimum/maximum
export const FINANCIAL_LIMITS = {
  MIN_PAYOUT_AMOUNT: 10,
  MIN_DEPOSIT_AMOUNT: 50,
  MAX_PAYOUT_AMOUNT: 10000,
  COMMISSION_RATE: PLATFORM_COMMISSION_RATE
};

// Types de vues du centre financier
export const VIEW_TYPES = {
  RENTER: 'renter',
  OWNER: 'owner'
};

// Labels des vues
export const VIEW_TYPE_LABELS = {
  [VIEW_TYPES.RENTER]: 'Vue Locataire',
  [VIEW_TYPES.OWNER]: 'Vue Propriétaire'
};

// Fréquences de payout
export const PAYOUT_FREQUENCIES = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  MANUAL: 'manual'
};

// Labels des fréquences
export const PAYOUT_FREQUENCY_LABELS = {
  [PAYOUT_FREQUENCIES.WEEKLY]: 'Hebdomadaire',
  [PAYOUT_FREQUENCIES.MONTHLY]: 'Mensuel',
  [PAYOUT_FREQUENCIES.MANUAL]: 'Manuel'
};

// ================================
// CONFIGURATION API
// ================================
export const FINANCIAL_API_ENDPOINTS = {
  RENTER_DASHBOARD: '/financial/renter/dashboard',
  RENTER_PAYMENT_HISTORY: '/financial/renter/payment-history',
  OWNER_DASHBOARD: '/financial/owner/dashboard',
  OWNER_PAYOUT_SETTINGS: '/financial/owner/payout-settings',
  OWNER_REQUEST_PAYOUT: '/financial/owner/request-payout',
  METRICS: '/financial/metrics'
};